class ComparisonSlider {
  constructor() {
    const cSlider = document.querySelector(".comparison-banner");

    if (cSlider) {
      const cSliderInput = cSlider.querySelector(".comparison-slider-input");
      const af = cSlider.querySelector(".comparison-after");
      const sliderBtn = cSlider.querySelector(".comparison-button");

      // Update the width of the foreground image
      af.style.width = "50%";
      af.style.backgroundSize = `${cSlider.offsetWidth}px 100%`;
      sliderBtn.style.left = `calc(50% - 15px)`;

      setTimeout(()=>{
        cSlider.classList.remove("loading");
      },500);

      cSliderInput.addEventListener("input", function (e) {
        let computedWidth = cSlider.offsetWidth;
        let sliderPos = e.target.value;
        sliderBtn.style.left = `calc(${sliderPos}% - 15px)`;
        af.style.width = sliderPos + "%";
        af.style.backgroundSize = `${computedWidth}px 100%`;
      });
    }
  }
}

export default new ComparisonSlider();
